import { Controller } from "stimulus";
import EasyMDE from "easymde";

import "easymde/dist/easymde.min.css";

export default class extends Controller {
  static targets = ["easymde"];

  connect() {
    console.log("connected MDE controller " + this.identifier);
    this.element[this.identifier] = this;
    this.mdes = [];

    for (let i = 0; i < this.easymdeTargets.length; i++) {
      this.mdes.push(new EasyMDE({
        autoDownloadFontAwesome: true,
        element: this.easymdeTargets[i],
        promptURLs: true,
        maxHeight: "600px",
        lineNumbers: false,
        spellChecker: false,
        toolbar: [
          "bold",
          "italic",
          "heading",
          "|",
          "quote",
          "unordered-list",
          "ordered-list",
          "horizontal-rule",
          /*{
            name: "todo-list",
            action: (editor) => {
                var cm = editor.codemirror;
                cm._toggleLine(cm, 'todo-list', '- [ ]')
              },
            className: "fa fa-bolt",
            title: "Bold",
          },*/
          "|",
          "link",
          "image",
          "table",
          "|",
          "preview",
          "guide",
        ],
      }));
    }
  }

  getMde() {
    return this.mdes[0];
  }
  change() {
    console.log("did mde change");
  }
}
